import { Hotel, Phone, Calendar, Plane } from 'lucide-react';

const QuickActionCard = ({ isAgent, quickActionType, quickActionData }) => {
  if (!quickActionData) return null;

  return (
    <div
      className={`mb-2.5 p-2.5 rounded-lg border-l-4 flex flex-col text-left ${
        isAgent
          ? 'bg-white/15 border-teal-200 text-white'
          : 'bg-teal-50/80 border-[#067978] text-gray-800'
      }`}
    >
      <div className="flex items-center gap-1.5 font-semibold text-[11px] mb-0.5">
        {quickActionType === 'travel_info' ? (
          <Plane className={`w-3.5 h-3.5 ${isAgent ? 'text-teal-200' : 'text-[#067978]'}`} />
        ) : quickActionType === 'contact_info' ? (
          <Phone className={`w-3.5 h-3.5 ${isAgent ? 'text-teal-200' : 'text-[#067978]'}`} />
        ) : quickActionType === 'schedule_info' || quickActionType === 'itinerary_info' ? (
          <Calendar className={`w-3.5 h-3.5 ${isAgent ? 'text-teal-200' : 'text-[#067978]'}`} />
        ) : (
          <Hotel className={`w-3.5 h-3.5 ${isAgent ? 'text-teal-200' : 'text-[#067978]'}`} />
        )}
        <span className={isAgent ? 'text-teal-200 font-bold' : 'text-[#067978] font-bold'}>
          {quickActionData.hotel_name ||
            quickActionData.contact_name ||
            quickActionData.event_title ||
            quickActionData.travel_name ||
            'Booking Reference'}
        </span>
      </div>
      <span className={`text-[10px] ${isAgent ? 'text-white/80' : 'text-gray-500'}`}>
        {quickActionType === 'contact_info'
          ? [quickActionData.role, quickActionData.phone].filter(Boolean).join(' • ')
          : quickActionType === 'schedule_info' || quickActionType === 'itinerary_info'
          ? [quickActionData.day_label, quickActionData.date, quickActionData.time]
              .filter(Boolean)
              .join(' • ')
          : [
              quickActionData.city,
              quickActionData.check_in_date ? `Check-in: ${quickActionData.check_in_date}` : '',
              quickActionData.source
                ? `${quickActionData.source} ➔ ${quickActionData.destination || ''}`
                : ''
            ]
              .filter(Boolean)
              .join(' • ')}
      </span>
    </div>
  );
};

export default QuickActionCard;
